import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useValidation } from 'components/modules/Insurance/hooks/useValidation';
import { updateDrivers } from 'store/insurance/actions';
import { insAnketaSetErrors, setDriverBatchState } from 'store/insuranceAnketa';
import { DRIVER_ERROR_PREFIX, DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { insuranceSetErrors } from 'store/insuranceCalculation';
import { FIELDS } from 'store/insuranceCalculation/constants';
import { selectInsuranceCalculation } from 'store/insuranceCalculation/selectors';

import { driversSchema, VALIDATION_KEYS } from '../DriverCard.validation';

export const useSubmit = ({ drivers, multidrive }) => {
  const dispatch = useDispatch();

  const {
    [FIELDS.MIN_DRIVERS_AGE]: minDriversAge,
    [FIELDS.MIN_DRIVERS_EXPERIENCE]: minDriversExperience,
  } = useSelector(selectInsuranceCalculation);

  const values = useMemo(() => {
    return {
      [VALIDATION_KEYS.DRIVERS]: drivers,
      [VALIDATION_KEYS.MULTIDRIVE]: multidrive,
      [VALIDATION_KEYS.MULTIDRIVE_DATA]: {
        [FIELDS.MIN_DRIVERS_AGE]: minDriversAge,
        [FIELDS.MIN_DRIVERS_EXPERIENCE]: minDriversExperience,
      },
    };
  }, [drivers, multidrive, minDriversAge, minDriversExperience]);

  const { validate } = useValidation({ schema: driversSchema, values });

  const onSubmit = useCallback(async () => {
    const {
      [VALIDATION_KEYS.DRIVERS]: driversErrors,
      [VALIDATION_KEYS.MULTIDRIVE_DATA]: multidriveDataErrors,
    } = await validate();
    const error = Boolean(driversErrors || multidriveDataErrors);

    if (driversErrors) {
      const errors = {};

      // В массиве может быть "empty" элемент
      for (let index = 0; index < driversErrors.length; index++) {
        const { [DRIVER_FIELDS.ID]: id } = drivers[index];

        const error = driversErrors[index] ?? {};

        // Раскрываем карточку водителя если есть ошибка
        if (driversErrors[index]) {
          dispatch(setDriverBatchState({ id, values: { [DRIVER_FIELDS.EDIT]: true } }));
        }

        errors[DRIVER_ERROR_PREFIX + id] ??= error;
      }

      dispatch(insAnketaSetErrors({ errors }));
    }

    if (multidriveDataErrors) {
      dispatch(insuranceSetErrors(multidriveDataErrors));
    }

    if (!error) {
      dispatch(updateDrivers());
    }
  }, [validate, drivers]);

  return { onSubmit };
};
